import { useTranslation } from "react-i18next";
import { translateDisplayText } from "@/shared/lib/translate";
import type { ReactNode } from "react";
import { cn } from "@/shared/lib/cn";
import { CreditsIcon } from "./icons";

/** The credit unit stays accessible while the shared icon identifies the amount visually. */
export function CreditAmount({ amount, creditLabel, className }: {
  amount: ReactNode;
  creditLabel?: ReactNode;
  className?: string;
}) {
  useTranslation();
  const unit = creditLabel ?? translateDisplayText(typeof amount === "number" && amount === 1 ? "credit" : "credits");
  return <span className={cn("inline-flex items-center gap-1 whitespace-nowrap font-semibold tabular-nums [&_svg]:size-4 [&_svg]:shrink-0", className)}>
    <CreditsIcon aria-hidden="true" />
    <span>{amount}<span className="sr-only"> {unit}</span></span>
  </span>;
}
